import SlackIcon from "../../assets/components/sources/SlackIcon";

const SlackLogomark = ({ height }: { height: number }) => {
  return <SlackIcon height={height} />;
};

export default SlackLogomark;
